export default __webpack_public_path__ + "static/media/items_ojk02.005b4400.jpg";